<template>
  <div>
    <!-- Edit Question -->
    <v-row class="ma-0 mb-3">
      <v-spacer />
      <v-btn
        color="primary"
        class="min-width-1"
        @click="handleEditItem(itemDetail)"
        >{{ $t("EDIT") }}</v-btn
      >
    </v-row>
    <ViewDetailConjugation :item="itemDetail" />
    <v-row class="ma-0 mt-6">
      <v-spacer />
      <v-btn class="min-width-1" @click="$router.go(-1)">{{
        $t("BACK")
      }}</v-btn>
    </v-row>
  </div>
</template>

<script>
// import Dialog from "@/components/Dialog/Dialog";
import mixin from "@/mixin";
import { getDetailQuestion } from "@/api/Question.api";
import ViewDetailConjugation from "@/views/drill/Exercises/ViewDetailConjugation.vue";
export default {
  store: ["formGeneral"],
  components: {
    // Dialog,
    ViewDetailConjugation,
  },
  mixins: [mixin.ValidateGeneral],
  data() {
    return {
      dialogViewGeneral: false,
      itemDetail: {},
    };
  },
  async created() {
    await this.handleGetDetail();
  },
  methods: {
    async handleGetDetail() {
      const { drillId, exerciesID } = this.$route.params;
      let params = {
        sub_key: drillId,
        id: exerciesID,
      };
      await getDetailQuestion(params).then(({ result }) => {
        const { lead_sentence, verb, list_answer, answer_correct } = result;
        this.itemDetail = result;
        this.formGeneral.leadSentence = lead_sentence;
        this.formGeneral.name1 = list_answer.sentence_answer[0];
        this.formGeneral.name2 = list_answer.sentence_answer[1];
        this.formGeneral.verb = verb;
        this.formGeneral.answersConjugation = list_answer.answer[0];
        this.formGeneral.wrongAnswersConjugation = list_answer.answer[1];
        this.formGeneral.isAnsewr = answer_correct[0];
      });
    },
    handleEditItem(item) {
      console.log(":item", item);
      const { drillId } = this.$route.params;
      const { no } = this.$route.query;
      this.$router.push({
        name: "Update Exercises Of Drill",
        params: {
          drillId,
          exerciesID: item.Id,
        },
        query: {
          no,
        },
      });
    },
  },
  // Set value default
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}

tr td {
  border: 1px solid #ccc;
  border-top: none;
}
</style>